"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  gradient,
  ...props
}) => {
  const iconSharedUtils = require('./utils/icon-shared-utils');
  const hasGradient = iconSharedUtils.hasValidGradient(gradient);
  let fillValue = color;
  let gradientDefs;
  let gradientUtils;
  if (hasGradient) {
    gradientUtils = iconSharedUtils.getGradientUtils();
    const iconWebUtils = require('./utils/icon-web-utils');
    const gradientId = gradientUtils.generateGradientId(gradient);
    fillValue = `url(#${gradientId})`;
    gradientDefs = iconWebUtils.renderWebGradientDefs(gradient, gradientId);
  }
  const svgContent = (0, _jsxRuntime.jsxs)("svg", {
    ...props,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: size,
    width: size,
    fill: fillValue,
    role: title ? 'img' : undefined,
    "aria-hidden": !title,
    "aria-labelledby": titleId,
    children: [title ? (0, _jsxRuntime.jsx)("title", {
      id: titleId,
      children: title
    }) : null, (0, _jsxRuntime.jsx)("path", {
      d: "M3.453 23a2.364 2.364 0 0 1-1.736-.717A2.364 2.364 0 0 1 1 20.547V9.921c0-.679.24-1.257.717-1.735a2.364 2.364 0 0 1 1.736-.717h17.094c.68 0 1.258.239 1.736.717S23 9.242 23 9.92v10.626c0 .68-.239 1.258-.717 1.736a2.364 2.364 0 0 1-1.736.717H3.453Zm0-2.453h17.094V9.921H3.453v10.626Zm7.342-1.644 4.753-3.152a.585.585 0 0 0 .275-.517.582.582 0 0 0-.275-.516l-4.753-3.153a.567.567 0 0 0-.63-.044.569.569 0 0 0-.321.54v6.347c0 .247.107.427.322.54a.567.567 0 0 0 .63-.045ZM4.453 6.39c-.305 0-.561-.103-.768-.31a1.043 1.043 0 0 1-.31-.768c0-.305.104-.561.31-.768.207-.206.463-.31.768-.31h15.094c.305 0 .561.104.768.31.206.207.31.463.31.768 0 .306-.104.562-.31.768-.207.207-.463.31-.768.31H4.453Zm3.235-3.234a1.04 1.04 0 0 1-.768-.31 1.043 1.043 0 0 1-.31-.768c0-.305.103-.561.31-.768A1.04 1.04 0 0 1 7.688 1h8.624c.306 0 .562.103.768.31.207.207.31.463.31.768 0 .306-.103.562-.31.768a1.04 1.04 0 0 1-.768.31H7.688Z"
    })]
  });
  return hasGradient ? gradientUtils.addGradientToSvg(svgContent, gradientDefs) : svgContent;
};